<template>
    <div id="primarySignupSetting">
        <div class="second-header-wrap">
            <el-button size="medium" @click="saveHandler" type="primary">保存</el-button>
            <el-button size="medium" @click="copyLastYear" type="primary">复制上一年设置</el-button>
        </div>
        <template v-for="level1Item in level1">
            <div class="header">
                <span class="color-block"></span>
                {{level1Item.fieldDesc}}
            </div>
            <div class="content">
                <span :class="['item-group', level2Item.has && level2Item.children && level2Item.children.length !== 0 ? 'item-group--expand' : '']" v-for="level2Item in getLevel2(level1Item.fieldName)">
                    <el-checkbox v-if="['stuName', 'gender', 'birthday', 'idCard', 'parentName', 'parentMobile'].indexOf(level2Item.fieldName) !== -1" :value="level2Item.has">
                        {{level2Item.fieldDesc}}
                    </el-checkbox>
                    <div v-else :is="level2Item.children && level2Item.children.length !== 0 ? 'div' : 'span'">
                        <br v-if="level2Item.fieldName === 'confirmHint'" />
                        <el-checkbox v-model="level2Item.has" @change="parentCheckboxChange(level2Item)">
                            {{level2Item.fieldDesc}}
                        </el-checkbox>
                        <span v-show="level2Item.has" v-if="level2Item.children && level2Item.children.length !== 0">
                            <template v-for="radioItem in level2Item.children">
                                <template v-if="radioItem.isRadio">
                                    <label role="radio" :class="['el-radio', radioItem.has ? 'is-checked' : '']">
                                        <span :class="['el-radio__input', radioItem.has ? 'is-checked' : '']">
                                            <span class="el-radio__inner"></span>
                                            <input type="radio" :checked="radioItem.has" @change="radioChange(level2Item, radioItem)" tabindex="-1" class="el-radio__original">
                                        </span>
                                        <span class="el-radio__label">{{radioItem.fieldDesc}}</span>
                                    </label>
                                </template>
                                <el-checkbox v-else-if="!radioItem.fieldLink || getItem(radioItem.fieldLink).has" v-model="radioItem.has" :label="radioItem">{{radioItem.fieldDesc}}</el-checkbox>
                            </template>
                        </span>
                    </div>


                    <span class="textarea-container" v-if="level2Item.isRemark" v-show="level2Item.has">
                        <el-input
                            type="textarea"
                            :rows="5"
                            :placeholder="level2Item.fieldDesc"
                            v-model="level2Item.fieldRemark"
                        >
                        </el-input>
                    </span>
                </span>
            </div>
        </template>

    </div>
</template>

<script>
    import {addSchoolEnrolField, getSchoolEnrolFieldList, copyBeforeFieldSetInfo} from '@/api/primary/setting.js';

    export default {
        name: "singupSetting",
        data: function () {
            return {
                signupSettingList: [{
                    fieldDesc: '学生基本信息',
                    fieldName: 'stuBaseInfo',
                    fieldRemark: '',
                    fieldType: '',
                    inputType: 7,
                    isFirst: 1,
                    has: true
                }, {
                    fieldDesc: '姓名',
                    fieldName: 'stuName',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '性别',
                    fieldName: 'gender',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '出生日期',
                    fieldName: 'birthday',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '身份证号',
                    fieldName: 'idCard',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 17,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '身高(字典项)',
                    fieldName: 'stature',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '体重(字典项)',
                    fieldName: 'weight',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '兴趣爱好特长(字典项)',
                    fieldName: 'interests',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                },{
                    fieldDesc: '家庭教育理念',
                    fieldName: 'familyJyln',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                },{
                    fieldDesc: '孩子近一年来的阅读书目',
                    fieldName: 'childJynYdsm',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                },{
                    fieldDesc: '孩子最喜欢的亲子活动项目',
                    fieldName: 'childZxhHdxm',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '民族',
                    fieldName: 'nation',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '籍贯',
                    fieldName: 'nativePlace',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 9,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '是否有重大疾病或过敏史',
                    fieldName: 'isMajorDis',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '是否单亲家庭',
                    fieldName: 'isSingleParent',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '证件照',
                    fieldName: 'childPhoto',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '户口类型(字典项)',
                    fieldName: 'nodeType',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 9,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '毕业学校',
                    fieldName: 'graduateSchool',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '所在班级',
                        fieldName: 'graduateClass',
                        fieldRemark: '',
                        fieldType: 'stuBaseInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }]
                }, {
                    fieldDesc: '家庭住址',
                    fieldName: 'homeCity',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '出生地',
                    fieldName: 'birthSite',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '出生证',
                    fieldName: 'birthProve',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '出生证编号',
                    fieldName: 'birthCertificateNo',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '预防接种证',
                    fieldName: 'vaccinateProve',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '是否独生子女',
                    fieldName: 'isSingleton',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false,
                    children: [ {
                        fieldDesc: '独生子女证',
                        fieldName: 'isOnlyChild',
                        fieldRemark: '',
                        fieldType: 'stuBaseInfo',
                        inputType: 11,
                        isFirst: 2,
                        has: false
                    }]
                }, 
                {
                    fieldDesc: '是否施教区学生',
                    fieldName: 'isTeachAreaStu',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 18,
                    isFirst: 9,
                    has: false
                },
                
                {
                    fieldDesc: '军人子女',
                    fieldName: 'isSoldierChild',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '非大孩',
                    fieldName: 'isBigBoy',
                    fieldRemark: '',
                    fieldType: 'stuBaseInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false
                }, {
                    // 222
                    fieldDesc: '监护人信息',
                    fieldName: 'parentsInfo',
                    fieldRemark: '',
                    fieldType: '',
                    inputType: '',
                    isFirst: 1,
                    has: true
                }, {
                    fieldDesc: '姓名',
                    fieldName: 'parentName',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '与孩子关系',
                    fieldName: 'nickCode',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '手机号',
                    fieldName: 'parentMobile',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 15,
                    isFirst: 2,
                    has: true
                }, {
                    fieldDesc: '身份证号',
                    fieldName: 'parentIdCard',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 17,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '学历(字典项)',
                    fieldName: 'parentEducation',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '职业类型(字典项)',
                    fieldName: 'dutyType',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '工作单位',
                    fieldName: 'parentWorkPlace',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '职务',
                    fieldName: 'duty',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '户籍所在地',
                    fieldName: 'residenceAddress',
                    fieldRemark: '',
                    fieldType: 'parentsInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    // 333
                    fieldDesc: '户籍及产权信息',
                    fieldName: 'addressInfo',
                    fieldRemark: '',
                    fieldType: '',
                    inputType: '',
                    isFirst: 1,
                    has: true
                }, {
                    fieldDesc: '户主',
                    fieldName: 'houseHolder',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '与孩子关系',
                    fieldName: 'holderRelation',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '学生落户时间',
                    fieldName: 'settleTime',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: false
                }, {
                    fieldDesc: '户籍地址',
                    fieldName: 'accAddress',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 7,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '填写',
                        fieldName: 'accAddressFill',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                        isRadio: true
                    }, {
                        fieldDesc: '施教区选择(字典项)',
                        fieldName: 'accAddressChoose',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: true
                    }]
                },  {
                    fieldDesc: '照片（户口本户首页、父亲页、母亲页、孩子页）',
                    fieldName: 'addressPhoto',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false,
                },  {
                    fieldDesc: '非本户籍地址户口证明',
                    fieldName: 'otherCertificate',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '产权类型',
                    fieldName: 'propertyType',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '商品房',
                        fieldName: 'propertyTypeOption101',
                        fieldRemark: '101',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '经济适用房',
                        fieldName: 'propertyTypeOption102',
                        fieldRemark: '102',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '公房',
                        fieldName: 'propertyTypeOption103',
                        fieldRemark: '103',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '小产权房',
                        fieldName: 'propertyTypeOption104',
                        fieldRemark: '104',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '自建住房',
                        fieldName: 'propertyTypeOption105',
                        fieldRemark: '105',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '产权房',
                        fieldName: 'propertyTypeOption106',
                        fieldRemark: '106',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '租赁房',
                        fieldName: 'propertyTypeOption107',
                        fieldRemark: '107',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '军产房',
                        fieldName: 'propertyTypeOption108',
                        fieldRemark: '108',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '其他',
                        fieldName: 'propertyTypeOption109',
                        fieldRemark: '109',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '备注',
                        fieldName: 'propertyTypeRemark',
                        fieldRemark: '',
                        fieldType: '',
                        fieldLink: 'propertyTypeOption109',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }]
                }, {
                    fieldDesc: '产权证（租赁证）号',
                    fieldName: 'propertyNo',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '所有产权人姓名',
                    fieldName: 'propertyHolder',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '产权人与孩子关系(字典项)',
                    fieldName: 'withChildRelation',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '产权关系',
                    fieldName: 'propertyRelation',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '孩子父母独立产权',
                        fieldName: 'propertyRelationOption1',
                        fieldRemark: '1',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '“四老”房产',
                        fieldName: 'propertyRelationOption2',
                        fieldRemark: '2',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '无房证明',
                        fieldName: 'propertyNaProve',
                        fieldRemark: '',
                        fieldLink: 'propertyRelationOption2',
                        fieldType: 'addressInfo',
                        inputType: 11,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '与老人共有房产',
                        fieldName: 'propertyRelationOption3',
                        fieldRemark: '3',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '拆迁过渡',
                        fieldName: 'propertyRelationOption4',
                        fieldRemark: '4',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '军产房',
                        fieldName: 'propertyRelationOption5',
                        fieldRemark: '5',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '无房户口空挂',
                        fieldName: 'propertyRelationOption6',
                        fieldRemark: '6',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '集体户口',
                        fieldName: 'propertyRelationOption7',
                        fieldRemark: '7',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '与他人共有产权',
                        fieldName: 'propertyRelationOption8',
                        fieldRemark: '8',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '产权占比',
                        fieldName: 'propertyRatio',
                        fieldRemark: '',
                        fieldType: '',
                        fieldLink: 'propertyRelationOption8',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }, {
                        fieldDesc: '其他',
                        fieldName: 'propertyRelationOption9',
                        fieldRemark: '9',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: false
                    }]
                }, {
                    fieldDesc: '产权地址',
                    fieldName: 'propertyAddress',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 7,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '填写',
                        fieldName: 'propertyAddressFill',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                        isRadio: true
                    }, {
                        fieldDesc: '施教区选择(字典项)',
                        fieldName: 'propertyAddressChoose',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 1,
                        isFirst: 2,
                        has: false,
                        isRadio: true
                    }]
                }, {
                    fieldDesc: '产权登记时间',
                    fieldName: 'propertyTime',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '建筑面积',
                    fieldName: 'propertyArea',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '丘权号',
                    fieldName: 'qiuNo',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '路段号',
                    fieldName: 'sectionNo',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 18,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '照片（产权证照片）',
                    fieldName: 'propertyPhoto',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 11,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '是否实际居住',
                    fieldName: 'isLive',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    children: [{
                        fieldDesc: '实际居住地址',
                        fieldName: 'actualAddress',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                    }, {
                        fieldDesc: '实际居住人员',
                        fieldName: 'liveMembers',
                        fieldRemark: '',
                        fieldType: 'addressInfo',
                        inputType: 5,
                        isFirst: 2,
                        has: false,
                    }]
                }, {
                    fieldDesc: '照片(房屋信息照片)',
                    fieldName: 'houseDetailsPhotos',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '家长备注',
                    fieldName: 'propertyRemark',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '家长确认备注',
                    fieldName: 'confirmHint',
                    fieldRemark: '',
                    fieldType: 'addressInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    isRemark: true
                }, {
                    fieldDesc: '审核信息',
                    fieldName: 'reviewInfo',
                    fieldRemark: '',
                    fieldType: '',
                    inputType: 1,
                    isFirst: 1,
                    has: true,
                }, {
                    fieldDesc: '实际居住',
                    fieldName: 'isRealLive',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '户籍所在地',
                    fieldName: 'isLocalRegister',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '施教区',
                    fieldName: 'isTeachArea',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '施教区入学审核通知',
                    fieldName: 'isTeachAreaNotice',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '父母产权',
                    fieldName: 'isProperty',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '是否家访',
                    fieldName: 'isVisit',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 1,
                    isFirst: 2,
                    has: false,
                }, {
                    fieldDesc: '其他审核信息',
                    fieldName: 'otherReview',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    isRemark: true
                }, {
                    fieldDesc: '显示报名编号',
                    fieldName: 'applyNo',
                    fieldRemark: '',
                    fieldType: 'reviewInfo',
                    inputType: 5,
                    isFirst: 2,
                    has: false,
                    isRemark: false
                }]
            }
        },
        computed: {
            level1: function () {
                return this.signupSettingList.filter(item => item.isFirst === 1)
            },
        },
        created() {
           this.getSchoolEnrolFieldListFunc();
        },
        methods: {
            getSchoolEnrolFieldListFunc() {
                getSchoolEnrolFieldList()
                    .then(res => res.data)
                    .then(data => {
                        data.data.forEach(item => {
                            this.signupSettingList.forEach(settingItem => {
                                if(item.fieldName === settingItem.fieldName) {
                                    settingItem.has = true;
                                    settingItem.fieldRemark = item.fieldRemark;
                                    return false;
                                } else if(settingItem.children && settingItem.children.length !== 0) {
                                    const childItem = settingItem.children.find(({fieldName}) => fieldName === item.fieldName);
                                    if(childItem) {
                                        childItem.has = true;
                                        return false;
                                    }
                                }
                            })
                        })
                    })
            },
            copyLastYear() {
                copyBeforeFieldSetInfo()
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                message: '复制成功',
                                type: 'success'
                            });
                            location.reload();
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            getItem(fieldName) {
                let result = null;
                this.signupSettingList.forEach(item => {
                    if(!result) {
                        if(item.fieldName === fieldName) {
                            result = item;
                        } else if(item.children && item.children.length !== 0) {
                            item.children.forEach(item => {
                                if (!result) {
                                    if (item.fieldName === fieldName) {
                                        result = item;
                                    }
                                }
                            });
                        }
                    }
                });
                return result;
            },
            parentCheckboxChange(item) {
                if(item.fieldName === 'propertyType' || item.fieldName === 'propertyRelation') {
                    item.children.forEach(subitem => subitem.has = item.has);
                }
            },
            getLevel2(fieldType) {
                return this.signupSettingList.filter(item => item.fieldType === fieldType);
            },
            radioChange(level2Item, radioItem) {
                level2Item.children.forEach(item => item.has = false);
                radioItem.has = true;

            },
            saveHandler() {
                const fieldList = [];
                const level1List = this.signupSettingList.filter(item => item.has && item.isFirst === 1).map(item => item.fieldName);
                const settingList = this.signupSettingList.filter(item => item.has && (item.isFirst === 1 || level1List.indexOf(item.fieldType) !== -1));
                settingList.forEach((item, index) => {
                    fieldList.push({
                        fieldDesc: item.fieldDesc,
                        fieldName: item.fieldName,
                        fieldRemark: item.fieldRemark,
                        fieldType: item.fieldType,
                        inputType: item.inputType,
                        isFirst: item.isFirst,
                        fieldValue: 1,
                        orderVal: fieldList.length
                    });

                    if(item.children) {
                        item.children.forEach(item => {
                            if(item.has) {
                                fieldList.push({
                                    fieldDesc: item.fieldDesc,
                                    fieldName: item.fieldName,
                                    fieldRemark: item.fieldRemark,
                                    fieldType: item.fieldType,
                                    inputType: item.inputType,
                                    isFirst: item.isFirst,
                                    fieldValue: 1,
                                    orderVal: fieldList.length
                                });
                            }
                        })
                    }
                });
                addSchoolEnrolField({
                    fieldJson: JSON.stringify(fieldList)
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                        }
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
    }

    .header {
        font-size: 18px;
        width: 250px;
        white-space: nowrap;
        margin: 16px 5px 6px 0;
        padding: 0 0 10px 0;

        .color-block {
            @include wh(12px, 12px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
        }
    }

    .content {
        margin: 10px 0;
        padding-left: 30px;
        font-size: 14px;
        width: 90%;
    }

    .textarea-container {
        display: inline-block;
        vertical-align: top;
        width: 70%;
    }
    .radio-label {
        margin-right: 30px;
    }
    .item-group {
        display: inline-block;
        padding: 3px;
         margin-bottom: 5px;
    }
    .item-group--expand {
        border: 1px dashed #409EFF;
    }
</style>
<style lang="scss">
    #primarySignupSetting {
        .el-checkbox__label {
            vertical-align: top;
            /*margin-bottom: 10px;*/
        }
        .el-radio:last-child {
            margin-right: 30px!important;
        }
        .el-checkbox:last-child {
            margin-right: 30px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/SignupSetting.vue